module.exports = __webpack_public_path__ + "img/blankscreen_300.03800983.jpg";